<div class="row g-0 m-0 d-flex align-items-center">
  <div class="col-md-1 pe-4 d-flex justify-content-end">
    <div class="button-back m-0" (click)="goBack()">
      <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
    </div>
  </div>
  <div class="col-md-8 pt-5 pb-3">
    <h2 class="col pb-2 title">
      {{ "MANAGE_VERSION" | translate }}
    </h2>
    <h6 class="col subtitle">
      {{ "MANAGE_VERSION_SUBTITLE" | translate }}
      @if (meterModel.model || meterModel.firmwareVersion) {
        <span>
          {{ meterModel.model }}@if (meterModel.firmwareVersion) {({{ meterModel.firmwareVersion }})}.
        </span>
      }
    </h6>
  </div>
  <div class="col-md-3 ps-5 pt-5 pb-5 pe-5 d-flex flex-row align-items-center justify-content-end">
    @if (selectedVersion != null) {
    <div class="button-wrapper ps-2" (click)="download()">
      <div class="button">
        <svg-icon alt="Download" src="../../../../../../assets/core/table/download-button.svg"
          title="{{ 'DOWNLOAD' | translate }}"></svg-icon>
      </div>
    </div>
    }
    <div class="button-wrapper ps-2" (click)="navigate('/upload/version')">
      <div class="button">
        <svg-icon alt="upload" src="../../../../../../assets/core/table/upload.svg"
          title="{{ 'UPLOAD' | translate }}"></svg-icon>
      </div>
    </div>
    @if (selectedVersion == null) {
      <button class="crud-add-button pt-2 pb-2 ms-4 ps-4 pe-4 rounded ms-2" [disabled]="form.invalid"
        (click)="isSaveModalOpen = true">
        {{ "APPROVE" | translate }}
      </button>
    }
  </div>
</div>

<form [formGroup]="form">
  <div class="p-5 pt-0 d-flex flex-column gap-3">
    <!-- Tab navigation -->
    <div class="row g-0 m-0">
      <ul class="tabs-nav">
        <li (click)="setActiveTab('associations')" [class.active]="activeTab === 'associations'">
          {{ "ASSOCIATIONS" | translate }}
        </li>
        @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList) ||
             isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod1_CaptureObjects) ||
             isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList) ||
             isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod2_CaptureObjects) ||
             isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList) ||
             isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod3_CaptureObjects)) {
        <li (click)="setActiveTab('load-profile')" [class.active]="activeTab === 'load-profile'">
          {{ "LOAD_PROFILE" | translate }}
        </li>
        }
        @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList) ||
             isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList) ||
             isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList)) {
        <li (click)="setActiveTab('push-interval')" [class.active]="activeTab === 'push-interval'">
          {{ "PUSH_INTERVAL" | translate }}
        </li>
        }
        @if (isAssociationSelected(DlmsAttributes.PushSetup_OnAlarm_ObjectList)) {
        <li (click)="setActiveTab('push-alarm')" [class.active]="activeTab === 'push-alarm'">
          {{ "PUSH_ON_ALARM" | translate }}
        </li>
        }
        @if (isAssociationSelected(DlmsAttributes.PushSetup_OnConnect_ObjectList)) {
        <li (click)="setActiveTab('push-connect')" [class.active]="activeTab === 'push-connect'">
          {{ "PUSH_ON_CONNECT" | translate }}
        </li>
        }
        @if (isAssociationSelected(DlmsAttributes.PushSetup_OnInstallation_ObjectList)) {
        <li (click)="setActiveTab('push-installation')" [class.active]="activeTab === 'push-installation'">
          {{ "PUSH_ON_INSTALLATION" | translate }}
        </li>
        }
        @if (isAssociationSelected(DlmsAttributes.PushSetup_OnPowerDown_ObjectList)) {
        <li (click)="setActiveTab('push-power-down')" [class.active]="activeTab === 'push-power-down'">
          {{ "PUSH_ON_POWER_DOWN" | translate }}
        </li>
        }
        @if (registers.length > 0) {
        <li (click)="setActiveTab('unsupported-registers')" [class.active]="activeTab === 'unsupported-registers'">
          {{ "UNSUPPORTED_REGISTERS" | translate }}
        </li>
        }
      </ul>
    </div>

    <!-- ======== TAB: ASSOCIATIONS ======== -->
    @if (activeTab === 'associations') {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="pb-4">
          <app-search placeholder="{{ 'SETTINGS_SEARCHBYNAME&OBISCODE' | translate }}"
            (searchChange)="searchChange($event)"></app-search>
        </div>
        <div class="association-table association-table-div">
          <div class="association-table-header">
            <div class="table-cell"></div>
            <div class="table-cell">{{ "NAME" | translate }}</div>
            <div class="table-cell">{{ "OBIS_CODE" | translate }}</div>
            <div class="table-cell">{{ "ATTRIBUTE_TYPE" | translate }}</div>
            <div class="table-cell">{{ "ATTRIBUTE_NO" | translate }}</div>
            <div class="table-cell">{{ "OBJECT_TYPE" | translate }}</div>
            <div class="table-cell">{{ "PARAMETER" | translate }}</div>
            <div class="table-cell">{{ "CONFIGURE" | translate }}</div>
          </div>
          <ng-container *ngIf="associationGroups.length">
            <cdk-virtual-scroll-viewport [itemSize]="50" class="association-viewport">
              <div *cdkVirtualFor="let row of filteredGroups"
                class="association-table-row align-items-center" [formGroup]="row">
                <div class="table-cell ps-1 click-target" (click)="toggleCellCheckbox($event)"
                  [attr.title]="showDebug ? 'ctrlDisabled=' + row.get('inUse')?.disabled : null">
                  <input type="checkbox" class="form-check-input custom-checkbox" formControlName="inUse"
                    (click)="$event.stopPropagation()" />
                </div>

                <div class="table-cell">
                  <span>{{ row.get('name')?.value }}</span>
                </div>

                <div class="table-cell">
                  <div class="form-input">
                    <div class="form-input-div">
                      <input type="text" formControlName="obis" [class.invalid-input]="getValidity(row, 'obis')"
                        [attr.title]="getValidity(row, 'obis') ? 'Value must be in format x.x.x.x.x.x' : ''" />
                    </div>
                  </div>
                </div>

                <div class="table-cell">
                  <div class="form-input">
                    <div class="form-input-div">
                      <select formControlName="attributeType">
                        <option *ngFor="let type of dataTypeDictionary" [value]="type">{{ type }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="table-cell">
                  <div class="form-input">
                    <div class="form-input-div">
                      <input type="number" min="0" max="100" formControlName="attributeNo"
                        [class.invalid-input]="getValidity(row, 'attributeNo')"
                        [attr.title]="getValidity(row, 'attributeNo') ? 'Value must be between 0 and 100' : ''" />
                    </div>
                  </div>
                </div>

                <div class="table-cell">
                  <div class="form-input">
                    <div class="form-input-div">
                      <input type="text" readonly formControlName="objectType"
                        [class.invalid-input]="getValidity(row, 'objectType')" />
                    </div>
                  </div>
                </div>

                <div class="table-cell">
                  <div class="form-input">
                    <div class="form-input-div">
                      <input type="number" min="0" max="100" formControlName="parameter"
                        [class.invalid-input]="getValidity(row, 'parameter')"
                        [attr.title]="getValidity(row, 'parameter') ? 'Value must be between 0 and 100' : ''" />
                    </div>
                  </div>
                </div>

                <div class="table-cell click-target" (click)="toggleCellCheckbox($event)"
                  [attr.title]="showDebug ? 'ctrlDisabled=' + row.get('configuredInSetup')?.disabled + ' | isConfigurable=' + isConfigurable(row) : null">
                  <div class="form-input">
                    <div class="form-input-div d-flex justify-content-center align-items-center">
                      <ng-container *ngIf="isConfigurable(row); else dash">
                        <input type="checkbox" class="form-check-input custom-checkbox"
                          formControlName="configuredInSetup" (click)="$event.stopPropagation()" />
                      </ng-container>
                      <ng-template #dash>/</ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
          </ng-container>
        </div>
      </div>
    </div>

    }

    <!-- ======== TAB: LOAD PROFILE ======== -->
    @if (activeTab === 'load-profile') {
    <div class="lp-layout" [class.lp-layout--collapsed]="recommendedCollapsed">
    <div class="lp-layout__divider">
      <button type="button" class="lp-layout__collapse-btn"
        [attr.title]="(recommendedCollapsed ? 'EXPAND_RECOMMENDED' : 'COLLAPSE_RECOMMENDED') | translate"
        (click)="recommendedCollapsed = !recommendedCollapsed">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
    <div class="lp-selector lp-layout__left">
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList) ||
           isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod1_CaptureObjects)) {
      <span (click)="activeLpTab = 'lp-1'" [class.lp-selector__item--active]="activeLpTab === 'lp-1'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "LOAD_PROFILE_1" | translate }}
      </span>
      }
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList) ||
           isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod2_CaptureObjects)) {
      <span (click)="activeLpTab = 'lp-2'" [class.lp-selector__item--active]="activeLpTab === 'lp-2'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "LOAD_PROFILE_2" | translate }}
      </span>
      }
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList) ||
           isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod3_CaptureObjects)) {
      <span (click)="activeLpTab = 'lp-3'" [class.lp-selector__item--active]="activeLpTab === 'lp-3'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "LOAD_PROFILE_3" | translate }}
      </span>
      }
    </div>
    @if (recommendedGroups) {
    <div class="recommended-panel__heading lp-layout__right">
      <span class="recommended-panel__title">{{ "RECOMMENDED_REGISTERS" | translate }}</span>
      <span class="recommended-panel__subtitle">{{ "RECOMMENDED_REGISTERS_SUBTITLE" | translate }}</span>
      <span class="recommended-panel__subtitle">{{ "RECOMMENDED_REGISTERS_NOTE" | translate }}</span>
    </div>
    }

    <div class="lp-layout__left">
    @if (activeLpTab === 'lp-1') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList) ||
    isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod1_CaptureObjects)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th class="ps-1">
                  <input type="checkbox" class="form-check-input custom-checkbox"
                    [checked]="lpHasSelection(LP1SetupConfiguration)"
                    [indeterminate]="lpHasSelection(LP1SetupConfiguration) && !lpAllSelected(LP1SetupConfiguration)"
                    [disabled]="isReadOnly || !lpHasSelection(LP1SetupConfiguration)"
                    [attr.title]="'CLEAR_SELECTION' | translate"
                    (change)="clearLpSelection(LP1SetupConfiguration, $event)" />
                </th>
                <th>{{ "NAME" | translate }}</th>
                <th>
                  {{ "OBIS_CODE" | translate }}
                  <span class="lp-selected-count">
                    {{ activeLpSelectedCount }}/{{ lpSelectionLimit }} {{ "SELECTED" | translate }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(LP1SetupConfiguration)"
                [attr.id]="'lp-row-' + row.attribute" [attr.title]="debugTitle(row, LP1SetupConfiguration)"
                [class.lp-row--highlighted]="row.attribute === highlightedAttribute"
                [class.lp-disabled]="row.disabledByOtherList || (isLpSelectionLimitReached(LP1SetupConfiguration) && !row.configure)"
                (click)="highlightAttribute(row.attribute)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, LP1SetupConfiguration)" [checked]="row.configure"
                    [disabled]="row.alwaysIncluded || isReadOnly || row.disabledByOtherList"
                    (click)="onLpSelectionAttempt($event, row, LP1SetupConfiguration)" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    @if (activeLpTab === 'lp-2') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList) ||
    isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod2_CaptureObjects)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th class="ps-1">
                  <input type="checkbox" class="form-check-input custom-checkbox"
                    [checked]="lpHasSelection(LP2SetupConfiguration)"
                    [indeterminate]="lpHasSelection(LP2SetupConfiguration) && !lpAllSelected(LP2SetupConfiguration)"
                    [disabled]="isReadOnly || !lpHasSelection(LP2SetupConfiguration)"
                    [attr.title]="'CLEAR_SELECTION' | translate"
                    (change)="clearLpSelection(LP2SetupConfiguration, $event)" />
                </th>
                <th>{{ "NAME" | translate }}</th>
                <th>
                  {{ "OBIS_CODE" | translate }}
                  <span class="lp-selected-count">
                    {{ activeLpSelectedCount }}/{{ lpSelectionLimit }} {{ "SELECTED" | translate }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(LP2SetupConfiguration)"
                [attr.id]="'lp-row-' + row.attribute" [attr.title]="debugTitle(row, LP2SetupConfiguration)"
                [class.lp-row--highlighted]="row.attribute === highlightedAttribute"
                [class.lp-disabled]="row.disabledByOtherList || (isLpSelectionLimitReached(LP2SetupConfiguration) && !row.configure)"
                (click)="highlightAttribute(row.attribute)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, LP2SetupConfiguration)" [checked]="row.configure"
                    [disabled]="row.alwaysIncluded || isReadOnly || row.disabledByOtherList"
                    (click)="onLpSelectionAttempt($event, row, LP2SetupConfiguration)" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    @if (activeLpTab === 'lp-3') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList) ||
    isAssociationSelected(DlmsAttributes.ProfileGeneric_LoadProfilePeriod3_CaptureObjects)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th class="ps-1">
                  <input type="checkbox" class="form-check-input custom-checkbox"
                    [checked]="lpHasSelection(LP3SetupConfiguration)"
                    [indeterminate]="lpHasSelection(LP3SetupConfiguration) && !lpAllSelected(LP3SetupConfiguration)"
                    [disabled]="isReadOnly || !lpHasSelection(LP3SetupConfiguration)"
                    [attr.title]="'CLEAR_SELECTION' | translate"
                    (change)="clearLpSelection(LP3SetupConfiguration, $event)" />
                </th>
                <th>{{ "NAME" | translate }}</th>
                <th>
                  {{ "OBIS_CODE" | translate }}
                  <span class="lp-selected-count">
                    {{ activeLpSelectedCount }}/{{ lpSelectionLimit }} {{ "SELECTED" | translate }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(LP3SetupConfiguration)"
                [attr.id]="'lp-row-' + row.attribute" [attr.title]="debugTitle(row, LP3SetupConfiguration)"
                [class.lp-row--highlighted]="row.attribute === highlightedAttribute"
                [class.lp-disabled]="row.disabledByOtherList || (isLpSelectionLimitReached(LP3SetupConfiguration) && !row.configure)"
                (click)="highlightAttribute(row.attribute)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, LP3SetupConfiguration)" [checked]="row.configure"
                    [disabled]="row.alwaysIncluded || isReadOnly || row.disabledByOtherList"
                    (click)="onLpSelectionAttempt($event, row, LP3SetupConfiguration)" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }
    </div>

    <!-- ======== RECOMMENDED REGISTERS ======== -->
    <div class="recommended-panel lp-layout__right subpage-container mb-5 p-3 pt-0">
      <div class="container g-0 m-0 p-0">
      @if (recommendedGroups; as groups) {
      @if (groups.length) {
      <table class="configuration-table recommended-table recommended-panel__header">
        <colgroup>
          <col class="recommended-table__check" />
          <col />
          <col class="recommended-table__obis" />
        </colgroup>
        <thead>
          <tr>
            <th class="ps-1">
              <input type="checkbox" class="form-check-input custom-checkbox" [checked]="allRecommendedSelected"
                [indeterminate]="someRecommendedSelected" [disabled]="isReadOnly"
                [attr.title]="'SELECT_ALL' | translate"
                (change)="toggleAllRecommended($event)" />
            </th>
            <th>{{ "NAME" | translate }}</th>
            <th>{{ "OBIS_CODE" | translate }}</th>
          </tr>
        </thead>
      </table>
      }
      @for (group of groups; track group.titleKey) {
      <div>
        <table class="configuration-table recommended-table">
          <colgroup>
            <col class="recommended-table__check" />
            <col />
            <col class="recommended-table__obis" />
          </colgroup>
          <tbody>
            @for (row of group.rows; track row.attribute) {
            <tr [class.recommended-row--blocked]="row.state === 'inOtherList' || row.state === 'unavailable'"
              [attr.title]="recommendedRowTitle(row)" (click)="focusRecommended(row)">
              <td class="ps-1">
                <input type="checkbox" class="form-check-input custom-checkbox" [checked]="row.state === 'selected'"
                  [disabled]="isRecommendedRowDisabled(row)" (change)="toggleRecommended(row)"
                  (click)="$event.stopPropagation()" />
              </td>
              <td>
                {{ row.name }}
                @if (row.otherLpTitleKey) {
                <span class="recommended-row__note">{{ row.otherLpTitleKey | translate }}</span>
                }
              </td>
              <td>{{ row.obis }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
      @if (!groups.length) {
      <p class="recommended-panel__hint pt-3 ps-1 m-0">{{ "NO_RECOMMENDED_REGISTERS" | translate }}</p>
      }
      }
      </div>
    </div>
    </div>
    }

    <!-- ======== TAB: PUSH INTERVAL ======== -->
    @if (activeTab === 'push-interval') {
    <div class="lp-selector">
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList)) {
      <span (click)="activeIntervalTab = 'interval-1'" [class.lp-selector__item--active]="activeIntervalTab === 'interval-1'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "PUSH_INTERVAL_1" | translate }}
      </span>
      }
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList)) {
      <span (click)="activeIntervalTab = 'interval-2'" [class.lp-selector__item--active]="activeIntervalTab === 'interval-2'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "PUSH_INTERVAL_2" | translate }}
      </span>
      }
      @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList)) {
      <span (click)="activeIntervalTab = 'interval-3'" [class.lp-selector__item--active]="activeIntervalTab === 'interval-3'" class="lp-selector__item p-3 pt-2 pb-2">
        {{ "PUSH_INTERVAL_3" | translate }}
      </span>
      }
    </div>

    @if (activeIntervalTab === 'interval-1') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval1_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(PushOnInterval1RequiredCaptureObjectsConfiguration)"
                [attr.title]="debugTitle(row, PushOnInterval1RequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnInterval1RequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    @if (activeIntervalTab === 'interval-2') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval2_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(PushOnInterval2RequiredCaptureObjectsConfiguration)"
                [attr.title]="debugTitle(row, PushOnInterval2RequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnInterval2RequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    @if (activeIntervalTab === 'interval-3') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_Interval3_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(PushOnInterval3RequiredCaptureObjectsConfiguration)"
                [attr.title]="debugTitle(row, PushOnInterval3RequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnInterval3RequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }
    }

    <!-- ======== TAB: PUSH ON ALARM ======== -->
    @if (activeTab === 'push-alarm') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_OnAlarm_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filterSetupsToDisplay(PushOnAlarmCaptureObjectsConfiguration); let i = index"
                [attr.title]="debugTitle(row, PushOnAlarmCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnAlarmCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    <!-- ======== TAB: PUSH ON CONNECT ======== -->
    @if (activeTab === 'push-connect') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_OnConnect_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of filterSetupsToDisplay(PushOnConnectRequiredCaptureObjectsConfiguration); let i = index"
                [attr.title]="debugTitle(row, PushOnConnectRequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnConnectRequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    <!-- ======== TAB: PUSH ON INSTALLATION ======== -->
    @if (activeTab === 'push-installation') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_OnInstallation_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of filterSetupsToDisplay(PushOnInstallationRequiredCaptureObjectsConfiguration); let i = index"
                [attr.title]="debugTitle(row, PushOnInstallationRequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnInstallationRequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }

    <!-- ======== TAB: UNSUPPORTED REGISTERS ======== -->
    @if (activeTab === 'unsupported-registers') {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table unsupported-registers-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
                <th>{{ "OBJECT_TYPE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of registers">
                <th></th>
                <td class="pe-4">{{ row.name }}</td>
                <td>{{ row.obis }}</td>
                <td>{{ row.objectType }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }

    <!-- ======== TAB: PUSH ON POWER DOWN ======== -->
    @if (activeTab === 'push-power-down') {
    @if (isAssociationSelected(DlmsAttributes.PushSetup_OnPowerDown_ObjectList)) {
    <div class="subpage-container mb-5">
      <div class="container g-0 m-0 p-0">
        <div class="overflow-vertical">
          <table class="configuration-table">
            <thead>
              <tr>
                <th></th>
                <th>{{ "NAME" | translate }}</th>
                <th>{{ "OBIS_CODE" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of filterSetupsToDisplay(PushOnPowerDownRequiredCaptureObjectsConfiguration); let i = index"
                [attr.title]="debugTitle(row, PushOnPowerDownRequiredCaptureObjectsConfiguration)">
                <td class="ps-1">
                  <input class="form-check-input custom-checkbox" type="checkbox"
                    (change)="toggleConfigure(row.id, PushOnPowerDownRequiredCaptureObjectsConfiguration)"
                    [checked]="row.configure" [disabled]="row.alwaysIncluded || isReadOnly"
                    (click)="$event.stopPropagation()" />
                </td>
                <td>{{ row.name }}</td>
                <td>{{ row.obis }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
    }
  </div>
</form>

<app-confirm-dialog *ngIf="isSaveModalOpen" titleKey="VERSION" question="MANAGE_VERSION_MODAL"
  (confirm)="onSubmit()" (cancel)="isSaveModalOpen = false"></app-confirm-dialog>